export interface IdentityPillar {
  slug: string;
  icon: string;
  wide?: boolean;
}

export interface IdentityValue {
  slug: string;
  icon: string;
}

export const pillars: IdentityPillar[] = [
  { slug: "mission", icon: "my_location", wide: true },
  { slug: "vision", icon: "visibility" },
  { slug: "business", icon: "insights" },
];

export const values: IdentityValue[] = [
  { slug: "commitment", icon: "handshake" },
  { slug: "cooperation", icon: "verified_user" },
  { slug: "effectiveness", icon: "trending_up" },
  { slug: "ethics", icon: "balance" },
  { slug: "deadlines", icon: "schedule" },
  { slug: "proactivity", icon: "bolt" },
  { slug: "legalCertainty", icon: "gavel" },
  { slug: "sustainability", icon: "eco" },
];
